import { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as SpecialActionIds from 'automation-ui-flow-core/canvas/SpecialActionIds';
import EnrollmentCard from 'automation-ui-canvas/components/enrollment/EnrollmentCard';
import GoToActionCardWrapper from 'automation-ui-canvas/action-features/go-to/GoToActionCardWrapper';
import { getFlowValidation } from 'automation-ui-canvas/selectors/flowSelectors';
import * as CanvasIdentifiers from 'automation-ui-flow-core/canvas/CanvasIdentifiers';
import EmptyActionCard from 'automation-ui-canvas/action-features/EmptyActionCard';
import ClassicVirtualAnchoredDelayActionCardWrapper from 'automation-ui-canvas/action-features/classic-virtual-anchored-delay/ClassicVirtualAnchoredDelayActionCardWrapper';
import { isGoToActionId } from 'automation-ui-action-features/records/recordsUtils';
import FlowActionNode from 'automation-ui-canvas/components/canvas/FlowActionNode';
import AppContext from 'automation-ui-core/context/AppContext';
import SimpleEnrollmentCard from 'automation-ui-canvas/components/enrollment/SimpleEnrollmentCard';
import { DETAIL_MIN_ZOOM_LEVEL } from 'automation-ui-flow-core/canvas/graphConstants';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FlowCanvasNode({
  id: nodeId,
  width,
  height,
  flow,
  isSelected = false,
  isHighlighted = false,
  isDisabled = false,
  clickable = true,
  readOnly = false,
  showIcon = true,
  isCanvasVirtualRenderingDisabled = false,
  objectsInActions = [],
  setShowLoadingOverlay,
  onSelectNode,
  selectedActionMetadataConfig = null,
  getActionOutputsForTargetActionById,
  disabledDescription,
  borderStyle,
  bannerText,
  bannerStyle,
  overrideTitleAction,
  overrideAccentColor,
  zoomLevel = 1
}) {
  const {
    flowId,
    objectTypeId,
    actions
  } = flow;
  const flowValidation = useSelector(getFlowValidation(flowId));
  const history = useHistory();
  const onClick = useCallback(event => onSelectNode && onSelectNode(nodeId, event), [nodeId, onSelectNode]);
  const layout = zoomLevel < DETAIL_MIN_ZOOM_LEVEL ? 'zoomed-out' : 'default';
  const {
    triggerContent
  } = useContext(AppContext);
  if (nodeId === CanvasIdentifiers.FIRST_NODE) {
    if (triggerContent) {
      return /*#__PURE__*/_jsx(SimpleEnrollmentCard, {
        flowObjectTypeId: objectTypeId,
        triggerContent: triggerContent,
        width: width,
        height: height,
        layout: layout
      });
    } else {
      return /*#__PURE__*/_jsx(EnrollmentCard, {
        flowId: flowId,
        flow: flow,
        flowObjectTypeId: objectTypeId,
        isSelected: isSelected,
        isHighlighted: isHighlighted,
        isDisabled: isDisabled,
        clickable: clickable,
        readOnly: readOnly,
        width: width,
        height: height,
        onClick: onClick,
        showLoadingOverlay: setShowLoadingOverlay,
        borderStyle: borderStyle,
        bannerText: bannerText,
        bannerStyle: bannerStyle,
        layout: layout,
        overrideTitleAction: overrideTitleAction
      });
    }
  }
  if (nodeId === CanvasIdentifiers.VIRTUAL_ANCHORED_DELAY_NODE) {
    return /*#__PURE__*/_jsx(ClassicVirtualAnchoredDelayActionCardWrapper, {
      isSelected: isSelected,
      isHighlighted: isHighlighted,
      isDisabled: isDisabled,
      width: width,
      height: height,
      onClick: onClick,
      borderStyle: borderStyle,
      bannerText: bannerText,
      layout: layout
    });
  }
  if (nodeId === SpecialActionIds.NEW_ACTION) {
    return /*#__PURE__*/_jsx(EmptyActionCard, {
      actionMetadataConfig: selectedActionMetadataConfig,
      width: width,
      height: height,
      showIcon: showIcon,
      borderStyle: borderStyle,
      bannerText: bannerText,
      layout: layout
    });
  }
  if (isGoToActionId(nodeId)) {
    return /*#__PURE__*/_jsx(GoToActionCardWrapper, {
      isSelected: isSelected,
      isHighlighted: isHighlighted,
      isDisabled: isDisabled,
      flowId: flowId,
      flow: flow,
      actionId: nodeId,
      readOnly: readOnly,
      width: width,
      height: height,
      showIcon: showIcon,
      onClick: onClick,
      borderStyle: borderStyle,
      bannerText: bannerText,
      overrideAccentColor: overrideAccentColor,
      layout: layout
    });
  }
  const action = actions.get(Number(nodeId));
  if (!action) {
    return null;
  }
  return /*#__PURE__*/_jsx(FlowActionNode, {
    nodeId: nodeId,
    action: action,
    flow: flow,
    flowValidation: flowValidation,
    isSelected: isSelected,
    onSelectAction: onSelectNode,
    isHighlighted: isHighlighted,
    isDisabled: isDisabled,
    clickable: clickable,
    flowId: flowId,
    history: history,
    readOnly: readOnly,
    isCanvasVirtualRenderingDisabled: isCanvasVirtualRenderingDisabled,
    getActionOutputsForTargetActionById: getActionOutputsForTargetActionById,
    objectsInActions: objectsInActions,
    width: width,
    height: height,
    showIcon: showIcon,
    showLoadingOverlay: setShowLoadingOverlay,
    disabledDescription: disabledDescription,
    borderStyle: borderStyle,
    bannerText: bannerText,
    overrideTitleAction: overrideTitleAction,
    overrideAccentColor: overrideAccentColor,
    layout: layout
  });
}